import React, { useEffect, useState } from "react";
import ctl from "@netlify/classnames-template-literals";

import HowNombaQRWorks from "videos/drivers/how-nomba-qr-works.mp4";
import HowNombaQRworksWebM from "videos/drivers/how-nomba-qr-works.webm";

import { Container } from "components";

const AboutNombaQRVideo = () => {
  const [isVideoVisible, setIsVideoVisible] = useState(false);

  useEffect(() => {
    const player = document.getElementById("video-player-two");

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVideoVisible(entry.isIntersecting);
      },
      { threshold: 0.512 }
    );

    observer.observe(player);

    return () => {
      observer.unobserve(player);
    };
  }, []);

  useEffect(() => {
    const player = document.getElementById("video-player-two");
    if (!isVideoVisible) {
      player.pause();
    } else {
      player.play();
    }
  }, [isVideoVisible]);

  return (
    <section className="relative bg-n-charcoal w-screen py-20 lg:py-[120px]">
      <Container className="flex">
        <video
          id="video-player-two"
          muted={!isVideoVisible}
          className={videoPlayerStyle}
          autoPlay
          controls
          loop
        >
          <source src={HowNombaQRWorks} type="video/mp4" />
          <source src={HowNombaQRworksWebM} type="video/webm" />
        </video>
      </Container>
    </section>
  );
};

const videoPlayerStyle = ctl(`
  bg-n-smoky
  lg:rounded-[32px]
  lg:w-[1272px]
  lg:h-[640px]
  rounded-2xl
  mx-auto
`);

export { AboutNombaQRVideo };
